import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const sdkRoutes: Routes = [
  {
    path: 'desbloqueio-usuario',
    loadChildren: () =>
      import('../pages/sdk/desbloqueio-usuario/desbloqueio-usuario.module').then(
        (module) => module.DesbloqueioUsuarioModule
      ),
    canActivate: [AuthGuard],
  },
];

